export const alertHeading = {
  fontSize: "26px",
  lineHeight: "32px",
  fontWeight: 'bold',
  fontFamily: "MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif",
  color: "#404040",
  marginBottom: "10px"
};
